import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Button,
  Typography,
  Grid,
  Fade,
  IconButton,
  TextField,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Link,
} from "@mui/material";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import EditIcon from "@mui/icons-material/Edit";
import dayjs from "dayjs";
import SnackbarAlert from "./SnackbarAlert";
import routes from "../routes";
import nucleusxp from "nucleusxp";
import EmergencyCall from "./HealthAndSafety/EmergencyCall";
import { useNavigate } from "react-router-dom";
import { calculateWorkingDays } from "./Holidays/dateUtils";
import { convertTimeToDate } from "../services/helper";
import { updateInLocalStorage } from "../services/localStorage";
import { convertFileFromBackendResponse } from "../services/helper";

const ConfirmModal = ({
  open,
  onClose,
  title,
  fields,
  formData,
  handleConfirm = null,
  isDraft = false,
  handleDraft = null,
  preview = false,
  handleEdit = null,
}) => {
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const [message, setMessage] = useState("");
  const [draft, setDraft] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openMessage, setOpenMessage] = useState(false);
  const [managerAction, setManagerAction] = useState("");

  const startDate = formData.dateRange && formData.dateRange[0];
  const endDate = formData.dateRange && formData.dateRange[1];

  let workingDays = 0;
  let totalWorkingDays = 0;
  let totalWorkingHours = 0;
  let totalWorkingMinutes = 0;
  if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    workingDays = calculateWorkingDays(start, end); // Calculate working days
  }
  useEffect(() => {
    if (formData.type === "holiday" || formData.type === "overtime") {
      if (formData.isDraft) {
        setDraft(true);
      } else {
        setDraft(false);
      }
    } else {
      if (formData.status === "Draft") {
        setDraft(true);
      }
    }
  }, [formData]);
  const handleEditClick = (field) => {
    onClose(
      field.name === "individualsList" ? "individualsAffected" : field.name,
      field.name !== "individualsList"
        ? formData[field.name]
        : formData["individuals"],
    );
  };
  const previewFile = async (file) => {
    if (!file.url) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const fileContent = event.target.result;
        const blob = new Blob([fileContent], { type: file.type });
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
      };

      reader.readAsArrayBuffer(file);
    } else {
      await convertFileFromBackendResponse(file);
    }
  };

  const hazards = JSON.parse(localStorage.getItem("hazards")) || [];
  // const reportedBy = JSON.parse(localStorage.getItem("reportedBy")) || [];
  const handleChange = (e) => {
    setMessage(e.target.value);
  };
  const handleManager = async () => {
    if (formData.type === "holiday") {
      updateInLocalStorage("holiday", formData.id, {
        ...formData,
        id: formData.id,
        isDraft: false,
        managerNotes: message,
        status: managerAction,
      });
      setLoading(false);
      setSnackbar({
        open: true,
        severity: "success",
        message: `A holiday Request is ${managerAction}!`,
      });
      navigate(routes.myHolidays.path, {
        state: {
          openInsight: true,
        },
      });
    } else if (formData.type === "overtime") {
      updateInLocalStorage("overtime", formData.id, {
        ...formData,
        id: formData.id,
        isDraft: false,
        managerNotes: message,
        status: managerAction,
      });
      setLoading(false);
      setSnackbar({
        open: true,
        severity: "success",
        message: `A Overtime Request is ${managerAction}!`,
      });
      navigate(routes.myHolidays.path, {
        state: {
          openInsight: true,
        },
      });
    } else {
      try {
        await nucleusxp.healthSafety.patchReport(formData.id, {
          ...formData,
          status: managerAction,
        });
        await nucleusxp.healthSafety.patchManagerReport(formData.id, {
          managerNotes: message,
        });
        setLoading(false);
        setSnackbar({
          open: true,
          severity: "success",
          message: `A ${formData.type} Request is ${managerAction === "Approved" ? "Escalate" : managerAction === "Rejected" ? "No action" : managerAction}!`,
        });
        navigate(routes.healthSafety.path, {
          state: {
            openInsight: true,
          },
        });
      } catch (e) {
        setLoading(false);
        setSnackbar({
          open: true,
          severity: "error",
          message: `Please check connection with server`,
        });
      }
    }
    onClose();
  };
  const handleApprove = async (e) => {
    e.preventDefault();
    setOpenMessage(true);
    setManagerAction("Approved");
  };
  const handleQuery = (e) => {
    e.preventDefault();
    setOpenMessage(true);
    setManagerAction("Queried");
  };
  const handleReject = async (e) => {
    e.preventDefault();
    setOpenMessage(true);
    setManagerAction("Rejected");
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSubmit = async () => {
    if (formData.type === "holiday") {
      updateInLocalStorage("holiday", formData.id, {
        ...formData,
        id: formData.id,
        isDraft: false,
        status: "Pending",
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: "A holiday Request is Pending!",
      });
      navigate(routes.myHolidays.path);
    } else if (formData.type === "overtime") {
      updateInLocalStorage("overtime", formData.id, {
        ...formData,
        id: formData.id,
        isDraft: false,
        status: "Pending",
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: "A Overtime Request is Pending!",
      });
      navigate(routes.myHolidays.path);
    } else {
      try {
        setLoading(true);
        await nucleusxp.healthSafety.patchReport(formData.id, {
          ...formData,
          status: "Pending",
        });
        setLoading(false);
        setSnackbar({
          open: true,
          severity: "success",
          message: `A ${formData.type} Request is Pending!`,
        });
        navigate(routes.healthSafety.path, {
          state: {
            openReport: true,
          },
        });
      } catch (e) {
        setSnackbar({
          open: true,
          severity: "error",
          message: `Please check connection with server`,
        });
      }
    }
    setDraft(false);
    onClose();
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          onClose();
        }}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box
            sx={{
              backgroundColor: "grey", // grey background
              padding: 0,
              borderRadius: 3,
              maxWidth: "90vw", // Ensure it fits the screen width
              overflow: "hidden",
              margin: "auto",
              marginTop: "5%",
              justifyContent: "center",
              alignItems: "center",
              maxHeight: "90vh", // Allow the modal to take up most of the screen height
              display: "flex",
              flexDirection: "column",
              boxShadow: 5,
              border: "1px solid #ddd",
              position: "relative", // for positioning the footer absolutely
            }}
          >
            {/* Fixed Header with Confirm Summary */}
            <Box
              sx={{
                p: 2,
                width: "90vw",
                paddingLeft: "60px",
                borderBottom: "1px solid #ddd",
                bgcolor: "#f5f5f5",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "20px",
                position: "sticky", // Fixed header
                top: 0, // Stick to the top
                zIndex: 10, // Make sure it stays above other content
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: 600, color: "#333" }}>
                {isDraft
                  ? "Confirm Save as Draft"
                  : formData.status === "Queried" && !formData.fromInsight
                    ? "Update and re-submit"
                    : "Confirm Report and Submit"}
              </Typography>
            </Box>

            {/* Content area with A4 aspect ratio */}
            <Box
              sx={{
                backgroundColor: "white", // white sheet inside modal
                padding: 3,
                display: "flex",
                justifyContent: "center", // Center horizontally
                alignItems: "center", // Center vertically

                maxWidth: "calc(100% - 100px)", // Limit width to 90% of the viewport width
                maxHeight: "80vh", // Limit height to 90% of the viewport height
                aspectRatio: "1 / 1.414", // Maintain A4 aspect ratio (210mm x 297mm)
                margin: "10 auto", // Ensure it is centered in the modal
                fontSize: "16px", // Default font size
                lineHeight: 1.5, // Default line height
                overflowY: "scroll", // Allow scrolling if content exceeds

                "@media (max-width: 600px)": {
                  fontSize: "14px", // Smaller font on small screens
                },
                "@media (max-width: 400px)": {
                  fontSize: "12px", // Further smaller font on very small screens
                },
              }}
            >
              <Grid container spacing={2} sx={{ background: "white" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "#333", marginLeft: "20px" }}
                >
                  {title}
                </Typography>
                {fields.map(
                  (field, index) =>
                    (field.name !== "managerNotes" ||
                      formData["managerNotes"] !== "") && (
                      <Grid
                        item
                        xs={12}
                        key={index}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <Grid item xs={4}>
                          <Typography variant="body1" sx={{ color: "#555" }}>
                            {field.label}
                          </Typography>
                        </Grid>
                        <Grid item xs={7}>
                          {/* Handle date range display */}
                          {field.name === "dateRange" ? (
                            <div>
                              <Typography
                                variant="body2"
                                sx={{ color: "#333" }}
                              >
                                {formData.dateRange &&
                                  formData.dateRange[0] && (
                                    <div>{`Start Date: ${convertTimeToDate(
                                      formData.dateRange[0],
                                    )}`}</div>
                                  )}
                                {formData.dateRange &&
                                  formData.dateRange[1] && (
                                    <div>{`End Date: ${convertTimeToDate(
                                      formData.dateRange[1],
                                    )}`}</div>
                                  )}
                              </Typography>
                              {/* Show the calculated working days */}
                              {startDate && endDate && (
                                <Typography
                                  variant="body2"
                                  sx={{ color: "#333", marginTop: 1 }}
                                >
                                  {workingDays} working day(s)
                                </Typography>
                              )}
                            </div>
                          ) : field.name === "dateOfObservation" ? (
                            <div>
                              <Typography
                                variant="body2"
                                sx={{ color: "#333" }}
                              >
                                {formData[field.name]
                                  ? dayjs(formData[field.name].$d).format(
                                      "Do MMMM YYYY, hh:mm A",
                                    ) // Extract and format the raw date
                                  : "N/A"}{" "}
                                {/* Fallback for empty values */}
                              </Typography>
                            </div>
                          ) : field.type === "dateRangeList" ? (
                            <div>
                              {formData[field.name] &&
                              formData[field.name].length > 0 ? (
                                formData[field.name].map(
                                  (overTimeEntry, index) => {
                                    // Convert overtime entry's duration to total days, hours, and minutes
                                    const days =
                                      overTimeEntry.duration?.days || 0;
                                    const hours =
                                      overTimeEntry.duration?.hours || 0;
                                    const minutes =
                                      overTimeEntry.duration?.minutes || 0;

                                    // Convert the total time of each entry into days, hours, and minutes
                                    const totalDays =
                                      days + Math.floor(hours / 24);
                                    const remainingHours = hours % 24;
                                    const remainingMinutes = minutes % 60;

                                    // Calculate total working time in days
                                    totalWorkingDays += totalDays;
                                    totalWorkingHours += hours;
                                    totalWorkingMinutes += minutes;
                                    if (totalWorkingMinutes >= 60) {
                                      totalWorkingHours += 1;
                                      totalWorkingMinutes %= 60;
                                    }
                                    if (totalWorkingHours >= 24) {
                                      totalWorkingDays += 1;
                                      totalWorkingHours %= 24;
                                    }

                                    return (
                                      <div key={index}>
                                        <Typography
                                          variant="body2"
                                          sx={{ color: "#333" }}
                                        >
                                          {overTimeEntry.dateRange &&
                                            overTimeEntry.dateRange[0] && (
                                              <div>{`Start Date: ${convertTimeToDate(
                                                overTimeEntry.dateRange[0],
                                              )}`}</div>
                                            )}
                                          {overTimeEntry.dateRange &&
                                            overTimeEntry.dateRange[1] && (
                                              <div>{`End Date: ${convertTimeToDate(
                                                overTimeEntry.dateRange[1],
                                              )}`}</div>
                                            )}
                                          {overTimeEntry.repeatDate && (
                                            <div>{`Repeat: ${overTimeEntry.repeatDate}  `}</div>
                                          )}
                                        </Typography>
                                        {/* Show the calculated working days, hours, and minutes */}
                                        <Typography
                                          variant="body2"
                                          sx={{ color: "#333", mt: 0.4, mb: 3 }}
                                        >
                                          <strong>{totalDays}</strong>{" "}
                                          <span
                                            style={{ fontWeight: "normal" }}
                                          >
                                            day(s)
                                          </span>
                                          ,&nbsp;
                                          <strong>{remainingHours}</strong>{" "}
                                          <span
                                            style={{ fontWeight: "normal" }}
                                          >
                                            hrs
                                          </span>
                                          , &nbsp;
                                          <strong>
                                            {remainingMinutes}
                                          </strong>{" "}
                                          <span
                                            style={{ fontWeight: "normal" }}
                                          >
                                            mins
                                          </span>
                                        </Typography>
                                      </div>
                                    );
                                  },
                                )
                              ) : (
                                <div>No overtime entries to show</div>
                              )}
                              {/* Display total accumulated time */}
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#333",
                                  fontWeight: "bold",
                                  marginTop: 1,
                                }}
                              >
                                <span style={{ fontWeight: "normal" }}>
                                  Total Overtime:&nbsp;
                                </span>
                                <strong>{totalWorkingDays}</strong>{" "}
                                <span style={{ fontWeight: "normal" }}>
                                  day(s)
                                </span>
                                ,&nbsp;
                                <strong>{totalWorkingHours}</strong>{" "}
                                <span style={{ fontWeight: "normal" }}>
                                  hrs
                                </span>
                                ,&nbsp;
                                <strong>{totalWorkingMinutes}</strong>{" "}
                                <span style={{ fontWeight: "normal" }}>
                                  min(s)
                                </span>
                              </Typography>
                            </div>
                          ) : field.name === "attachedFile" &&
                            Array.isArray(formData.attachedFile) ? (
                            <div>
                              {/* Handle multiple files in attachedFile array */}
                              {formData.attachedFile.map((file, index) => (
                                <div key={index} style={{ marginTop: "10px" }}>
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "#333" }}
                                  >
                                    {file.url ? file.filename : file.name}
                                  </Typography>
                                  {!file.url ? (
                                    <Button
                                      onClick={() => previewFile(file)}
                                      variant="outlined"
                                      sx={{
                                        marginTop: "10px",
                                        color: "#2d3648",
                                        border: "2px solid #2d3648",
                                        textTransform: "capitalize",
                                        fontWeight: "700",
                                      }}
                                    >
                                      PREVIEW
                                    </Button>
                                  ) : (
                                    <Link
                                      href={file.url}
                                      download={file.filename}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      variant="outlined"
                                      sx={{
                                        marginTop: "10px",
                                        color: "#2d3648",
                                        border: "2px solid #2d3648",
                                        textTransform: "capitalize",
                                        fontWeight: "700",
                                        padding: "6px 16px", // Adjust to match Button padding
                                        display: "inline-block", // Makes it look like a button
                                        textAlign: "center", // Centers the text
                                        borderRadius: "4px", // Adds rounded corners
                                        textDecoration: "none", // Removes underline
                                        "&:hover": {
                                          backgroundColor: "#f5f5f5", // Matches Button hover style
                                        },
                                      }}
                                    >
                                      PREVIEW
                                    </Link>
                                  )}
                                </div>
                              ))}
                            </div>
                          ) : field.name === "categoryType" ? (
                            <Typography variant="body2" sx={{ color: "#333" }}>
                              {hazards[formData[field.name] - 1]?.name ||
                                "Unknown Hazard"}
                            </Typography>
                          ) : field.name === "reportedBy" ? (
                            <Typography variant="body2" sx={{ color: "#333" }}>
                              {/* {reportedBy[formData[field.name] - 1]?.name ||
                                "Unknown reporter"} */}
                              {formData[field.name]}
                            </Typography>
                          ) : field.name === "individualsList" ? (
                            <Typography variant="body2" sx={{ color: "#333" }}>
                              {formData["individuals"]
                                ? formData["individuals"].map((individual) => (
                                    <>
                                      <Grid
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                          spacing: 1,
                                          gap: 1,
                                        }}
                                      >
                                        <Typography variant="body1">
                                          Name
                                        </Typography>
                                        <Typography variant="body3">
                                          {individual.name}
                                        </Typography>
                                        {individual.bodyPartsAffected &&
                                          individual.bodyPartsAffected.length >
                                            0 && (
                                            <>
                                              <Typography variant="body1">
                                                Parts
                                              </Typography>
                                              {
                                                <Typography variant="body3">
                                                  {individual.bodyPartsAffected.join(
                                                    ", ",
                                                  )}
                                                </Typography>
                                              }
                                            </>
                                          )}
                                      </Grid>
                                    </>
                                  ))
                                : formData["individualsList"]
                                  ? formData["individualsList"].map(
                                      (individual) => (
                                        <>
                                          <Grid
                                            sx={{
                                              display: "flex",
                                              flexDirection: "row",
                                              spacing: 1,
                                              gap: 1,
                                            }}
                                          >
                                            <Typography variant="body1">
                                              Name
                                            </Typography>
                                            <Typography variant="body3">
                                              {individual}
                                            </Typography>
                                            {formData["bodyPartsData"] &&
                                              formData["bodyPartsData"].filter(
                                                (body) =>
                                                  body.name === individual,
                                              ).length > 0 && (
                                                <>
                                                  <Typography variant="body1">
                                                    Parts
                                                  </Typography>
                                                  {formData["bodyPartsData"]
                                                    .filter(
                                                      (body) =>
                                                        body.name ===
                                                        individual,
                                                    )
                                                    .map((body, index) => (
                                                      <Typography
                                                        key={index}
                                                        variant="body3"
                                                      >
                                                        {Object.keys(
                                                          body.bodyParts,
                                                        ).join(", ")}
                                                      </Typography>
                                                    ))}
                                                </>
                                              )}
                                          </Grid>
                                        </>
                                      ),
                                    )
                                  : ""}
                            </Typography>
                          ) : field.name === "managerNotes" ? (
                            formData[field.name] !== "" && (
                              <Typography
                                variant="body2"
                                sx={{ color: "#333" }}
                              >
                                {formData[field.name]}
                              </Typography>
                            )
                          ) : field.name === "equipmentList" ? (
                            <Typography variant="body2" sx={{ color: "#333" }}>
                              {formData["equipmentList"]
                                ? formData["equipmentList"]
                                    .map((equip) => equip.name)
                                    .join(", ")
                                : ""}
                            </Typography>
                          ) : field.name === "materialList" ? (
                            <Typography variant="body2" sx={{ color: "#333" }}>
                              {formData["materialList"]
                                ? formData["materialList"]
                                    .map((material) => material.name)
                                    .join(", ")
                                : ""}
                            </Typography>
                          ) : (
                            <Typography variant="body2" sx={{ color: "#333" }}>
                              {formData[field.name]}
                            </Typography>
                          )}
                        </Grid>

                        {/* Edit Icon */}
                        {!formData.fromInsight &&
                          field.name !== "managerNotes" && (
                            <Grid item xs={1}>
                              <IconButton
                                onClick={() => handleEditClick(field)}
                                sx={{
                                  color: "primary.main",
                                  padding: 0,
                                  marginLeft: 1,
                                }}
                              >
                                <EditIcon />
                              </IconButton>
                            </Grid>
                          )}
                      </Grid>
                    ),
                )}
              </Grid>
            </Box>

            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                color: "#333",
                marginBottom: 10,
              }}
            >
              Page 1 of 1{" "}
              {/* Add logic for multiple pages if content exceeds */}
            </Typography>

            {/* Fixed Footer with Confirm button */}
            {!preview ? (
              <Box
                sx={{
                  position: "absolute", // fix position at the bottom
                  bottom: 0,
                  left: 0,
                  right: 0,
                  display: "flex",
                  justifyContent: "space-between",
                  padding: 2,
                  borderTop: "1px solid #ddd",
                  bgcolor: "#f5f5f5",
                }}
              >
                <Button variant="outlined" onClick={onClose}>
                  Back to Editing
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={!isDraft ? handleConfirm : handleDraft}
                  sx={{ height: "fit-content" }}
                >
                  Confirm
                </Button>
              </Box>
            ) : (
              <Box
                sx={{
                  position: "absolute", // fix position at the bottom
                  bottom: 0,
                  left: 0,
                  right: 0,
                  display: "flex",
                  justifyContent: "space-between",
                  padding: 2,
                  borderTop: "1px solid #ddd",
                  bgcolor: "#f5f5f5",
                }}
              >
                {!formData.fromInsight ? (
                  <Button variant="outlined" onClick={onClose}>
                    Confirm
                  </Button>
                ) : (
                  <Button variant="outlined" onClick={onClose}>
                    <ChevronLeft />
                  </Button>
                )}
                {formData.fromInsight &&
                (formData.type === "holiday" ||
                  formData.type === "overtime") ? (
                  <Grid container spacing={2} sx={{ justifyContent: "center" }}>
                    {/* Approve and Reject buttons on the same row */}
                    <Grid item>
                      <Button
                        variant="contained"
                        color="success"
                        sx={{ marginRight: "10px" }} // Margin to the right for spacing
                        onClick={handleApprove}
                      >
                        Approve
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ marginRight: "10px" }} // Margin to the right for spacing
                        onClick={handleQuery}
                      >
                        Query
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleReject}
                      >
                        Reject
                      </Button>
                    </Grid>
                  </Grid>
                ) : (
                  formData.fromInsight && (
                    <Grid
                      container
                      spacing={2}
                      sx={{ justifyContent: "center" }}
                    >
                      {/* Approve and Reject buttons on the same row */}
                      <Grid item>
                        <Button
                          variant="contained"
                          color="success"
                          sx={{ marginRight: "10px" }} // Margin to the right for spacing
                          onClick={handleApprove}
                        >
                          Escalate
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{ marginRight: "10px" }} // Margin to the right for spacing
                          onClick={handleQuery}
                        >
                          Query
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          color="error"
                          onClick={handleReject}
                        >
                          No action Req.
                        </Button>
                      </Grid>
                    </Grid>
                  )
                )}

                {!draft ? (
                  !formData.fromInsight && formData.status === "Queried" ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleEdit}
                      sx={{ height: "fit-content" }}
                    >
                      Update
                    </Button>
                  ) : (
                    !formData.fromInsight && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleEdit}
                        sx={{ height: "fit-content" }}
                      >
                        Edit
                      </Button>
                    )
                  )
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    sx={{ height: "fit-content" }}
                  >
                    Submit
                  </Button>
                )}
              </Box>
            )}
          </Box>
        </Fade>
      </Modal>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1000,
        }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackbarAlert
        open={snackbar.open}
        onClose={handleClose}
        severity={snackbar.severity}
        message={snackbar.message}
      />

      <Dialog open={openMessage} onClose={() => setOpenMessage(false)}>
        <DialogTitle>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Do you want to leave message?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <>
            {managerAction === "Approved" && formData.reportType && (
              <Grid>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                  }}
                >
                  <EmergencyCall />
                  <Button
                    variant="contained"
                    sx={{ ml: "2.5px", fontSize: "12px", lineHeight: "18px" }}
                    color="primary"
                  >
                    Notify
                  </Button>
                  <Button
                    variant="contained"
                    sx={{ ml: "2.5px", fontSize: "12px", lineHeight: "18px" }}
                    color="primary"
                  >
                    Site Visit
                  </Button>
                  <Button
                    variant="contained"
                    sx={{ ml: "2.5px", fontSize: "12px", lineHeight: "18px" }}
                    color="primary"
                  >
                    First Aid
                  </Button>
                </Box>
              </Grid>
            )}

            <Grid>
              <TextField
                margin="normal"
                label="message "
                multiline
                rows={4}
                name="message"
                value={message}
                sx={{ width: "100%" }}
                onChange={handleChange}
                autoFocus
              />
            </Grid>
          </>
        </DialogContent>
        <Box p={2} display="flex" justifyContent="space-between">
          <Button onClick={() => setOpenMessage(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setLoading(true);
              handleManager();
              setOpenMessage(false);
              setMessage("");
            }}
            variant="contained"
            color="primary"
          >
            Respond
          </Button>
        </Box>
      </Dialog>
    </>
  );
};

export default ConfirmModal;
